const initialState = {
  groupOpen: [],
  groupActive: [],
  activeItem: null,
  userNavigation: []
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case 'SET_NAVIGATION':
      return { ...state, [payload.key]: payload.val }
    default:
      return state
  }
}
